import React, { useState, useEffect } from "react";
import { Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import { SERVER_PATH } from "../../config/env";
import productOne from "../../assets/img/herbalProduct.webp";
import healthAndWell from "../../assets/img/yoga/sivam_main_img.jpg";
import productTwo from "../../assets/img/gardenProduct.webp";
import productThree from "../../assets/img/yogaProduct.webp";
import productFour from "../../assets/img/spicesProduct.webp";
import productFive from "../../assets/img/foodProduct.jpg";

const titleStyles = {
  fontSize: ".9em",
};

export default function ProductLayout() {
  const [pathMap, setPathMap] = useState({});

  useEffect(() => {
    axios
      .get(`${SERVER_PATH}get/navbar.php?t=${Date.now()}`)
      .then((res) => {
        if (res.data && res.data.path_map) {
          setPathMap(res.data.path_map);
        }
      })
      .catch((err) => {});
  }, []);

  const productData = [
    {
      path: pathMap.herbal || "/herbalProduct",
      img: productOne,
      title: "Herbal Products",
    },
    {
      path: pathMap.wellness || "/yoga",
      img: healthAndWell,
      title: "Health And Wellness",
    },
  ];
  return (
    <>
      {productData.map((data, index) => {
        return (
          <Col className="col-md" key={index + "product"}>
            <div className="card h-100 ">
              <Link to={data.path}>
                <img
                  src={data.img}
                  className="card-img-top"
                  alt="sivamfarms products"
                  style={{height:"170px"}}
                />
              </Link>
              <div className="card-body">
                <Link
                  to={data.path}
                  className="h6 text-decoration-none text-uppercase text-dark productTitle"
                  style={titleStyles}>
                  {data.title}
                </Link>
              </div>
            </div>
          </Col>
        );
      })}
    </>
  );
}
